import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ItemsHelperService {
  private searchTerm = new BehaviorSubject<string>('');
  searchTerm$ = this.searchTerm.asObservable();

  private selectedTheme = new BehaviorSubject<number>(0);
  selectedTheme$ = this.selectedTheme.asObservable();

  private selectedFollowingType = new BehaviorSubject<boolean>(false);
  selectedFollowingType$ = this.selectedFollowingType.asObservable();

  mapsStyles = [
    {
      "featureType": "all",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#202c3e"
        }
      ]
    },
    {
      "featureType": "all",
      "elementType": "labels.text.fill",
      "stylers": [
        {
          "color": "#666666"
        }
      ]
    },
    {
      "featureType": "all",
      "elementType": "labels.text.stroke",
      "stylers": [
        {
          "color": "#000000"
        }
      ]
    },
    {
      "featureType": "all",
      "elementType": "labels.icon",
      "stylers": [
        {
          "visibility": "off"
        }
      ]
    },
    {
      "featureType": 'poi.park',
      "elementType": 'geometry',
      "stylers": [{ color: '#393939' }]
    },
    {
      "featureType": "landscape",
      "elementType": "geometry",
      "stylers": [
        {
          "color": "#393939"
        }
      ]
    },
    {
      "featureType": "poi",
      "elementType": "geometry",
      "stylers": [
       
      ]
    },
    {
      "featureType": "road",
      "elementType": "geometry",
      "stylers": [
       
      ]
    },
    {
      "featureType": "road",
      "elementType": "geometry.fill",
      "stylers": [
        {
          "color": "#2b2b2b"
        }
      ]
    },
    {
      "featureType": "road",
      "elementType": "geometry.stroke",
      "stylers": [
       
      ]
    },
    {
      "featureType": "water",
      "elementType": "all",
      "stylers": [
        {
          "color": "#2b2b2b"
        }
      ]
    }
  ]

  constructor() { }

  setSearchTerm(term: string) {
    this.searchTerm.next(term);
  }

  selectTheme(data: number) {
    this.selectedTheme.next(data);
  }

  selectFtype(data: boolean) {
    this.selectedFollowingType.next(data);
  }

  formatDataForMarkers(data: any[]): any {
    const transformedDataArray = data.map(data => ({
      coordinate: {
        lat: data.average_location.latitude,
        lng: data.average_location.longitude
      },
      is_single_item_group: data.is_single_item_group,
      items: data.items
    }));
    return transformedDataArray;
  }
}
